/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Asset identifier status refers to type of an asset in context of ghost machine.
 *
 */
export var AssetIdentifierStatus;
(function (AssetIdentifierStatus) {
    AssetIdentifierStatus["KNOWN"] = "Known";
    AssetIdentifierStatus["UNKNOWN"] = "Unknown";
    AssetIdentifierStatus["DELETED"] = "Deleted";
})(AssetIdentifierStatus || (AssetIdentifierStatus = {}));
